import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {
  McqDashboardComponent, ResultComponent, InvitationFormComponent, RegisterComponent,
  RegisterationComponent, ThanksComponent, NavigatorComponent
} from './components';
import { AuthGuardGuard } from './services/authguard/auth-guard.guard';
import { StageComponent } from './components/MCQTest/stage/stage.component';
import { RegisterUserComponent } from './components/MCQTest/register-user/register-user.component';
import { InvalidUrlComponent } from './components/MCQTest/invalid-url/invalid-url.component';
import { TestInstructionsComponent } from './components/MCQTest/test-instructions/test-instructions.component';
import { PortalLinkComponent } from './components/portal-link/portal-link.component';
import { CongratulationSorryPageComponent } from './components/MCQTest/congratulation-sorry-page/congratulation-sorry-page.component';
import { RedirectFromBridgelabzComponent } from './components/MCQTest/redirect-from-bridgelabz/redirect-from-bridgelabz.component';
import { CodingClubResultComponent } from './components/MCQTest/coding-club-result/coding-club-result.component';
import { InternalServerErrorComponent } from './components/MCQTest/internal-server-error/internal-server-error.component';
import { BteqRegisterUserComponent } from './components/MCQTest/bteq-register-user/bteq-register-user.component';

const routes: Routes = [
  { path: 'test', component: McqDashboardComponent, canActivate: [AuthGuardGuard] },
  { path: 'stage/:stageName', component: StageComponent },
  // {path: 'register/:shortName', component: RegisterUserComponent},
  // {path: 'bteq/register/:shortName', component: BteqRegisterUserComponent},
  {path: 'register/:shortName', component: BteqRegisterUserComponent},
  {path: 'economictimes/:shortName/:accesstoken', component: TestInstructionsComponent},
  { path: 'result', component: ResultComponent ,  canActivate: [AuthGuardGuard]},
  { path: 'ccresult', component: CodingClubResultComponent ,canActivate: [AuthGuardGuard] },
  { path: 'thank-you', component: ThanksComponent ,  canActivate: [AuthGuardGuard]},
  { path: 'not-found/:message/:statusCode', component: InvalidUrlComponent},
  { path: 'etresult', component: CongratulationSorryPageComponent ,canActivate: [AuthGuardGuard]},
  { path: 'portal-link', component: PortalLinkComponent},
  { path: 'thank-you1', component: ThanksComponent},
  { path: 'test/:token/:userName/:campaignShortName', component: RedirectFromBridgelabzComponent},
  {path:'error/:status',component:InternalServerErrorComponent},
  {path:'error',component:InternalServerErrorComponent},
  { path: '**', component: InvalidUrlComponent  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: []
})

export class AppRoutingModule { }

